export default {
    getActiveTab(state){
        return state.activeTab
    },
    getArticleList(state) {
        return state.articleList;
    },
    getPageSize(state) {
        return state.pageSize;
    },
    getCurrentPage(state) {
        return state.currentPage;
    },
    getCurrentCateId(state) {
        return state.currentCateId;
    },
}


// WEBPACK FOOTER //
// ./src/store/getters.js